import { LOAD_TAXONOMY } from '../constants/ActionTypes';

const initialState = {
  loaded: false,
  loading: false,
  error: null,
};

export function taxonomies(state = initialState, action) {
  switch (action.type) {
    case `${LOAD_TAXONOMY}_PENDING`:
      return {
        ...state,
        [action.taxonomy]: {
          ...(state[action.taxonomy] || {
            data: {},
            lastFetched: null,
          }),
          error: null,
          loaded: false,
          loading: true,
        },
      };

    case `${LOAD_TAXONOMY}_SUCCESS`:
      return {
        ...state,
        [action.taxonomy]: {
          error: null,
          data: action.result,
          lastFetched: Date.now(),
          loaded: true,
          loading: false,
        },
      };

    case `${LOAD_TAXONOMY}_FAIL`:
      return {
        ...state,
        [action.taxonomy]: {
          error: action.error,
          data: {},
          lastFetched: null,
          loading: false,
          loaded: false,
        },
      };

    default:
      break;
  }
  return state;
}
